import React, {useEffect, useRef, useState} from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'
import { Button } from '../Button'
import styles from './dock.module.scss'
import { getText } from '../../../internal/TextLabels'

export const Dock = props => {
  const ref = useRef(null)

  useEffect(() => {
    const handleResize = () => {
      const { height, top } = ref.current.getBoundingClientRect()
      if (height + top > window.innerHeight) {
        ref.current.style.height = `${window.innerHeight - top}px`
        ref.current.style.maxHeight = '100%'
        ref.current.style.overflow = 'auto'
      } else {
        ref.current.style.height = `${height + top}px`
        ref.current.style.maxHeight = ''
      }
    }

    handleResize()
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <div ref={ref} className={`${midas.container} ${props.dockClass}`}>
      <div className={`${midas.card} ${styles.dockCard}`}>
        <div className={`${styles.dockHeader} ${midas.cardHeader}`}>
          {props.title && <h4 className={styles.dockTitle}>{props.title}</h4>}
          <div className={styles.buttonDiv}>
            {props.onMinimize && (
              <button
                type="button"
                className={styles.dockButton}
                aria-label={getText("default.minimize")}
                title={getText("default.minimize")}
                // Do not remove the arrow function wrapper here, as it is required
                // to correctly pass the arguments to onMinimize().
                onClick={() => props.onMinimize()}
              >
                <i className={styles.iconMinimize} />
              </button>
            )}
            {props.onBeforeCloseChat ? (
              <button
                type="button"
                className={styles.dockButton}
                aria-label={props.closeText}
                onClick={() => props.onBeforeCloseChat()}
                title={props.closeText}
              >
                <i className={styles.iconClose} />
              </button>
            ) : (
              <button
                type="button"
                className={styles.dockButton}
                aria-label={props.closeText}
                onClick={props.onBack}
                title={props.closeText}
              >
                <i className={styles.iconClose} />
              </button>
            )}
          </div>
        </div>
        <div className={midas.cardBody} style={{ paddingTop: '0' }}>
          <div className={midas.content}>{props.children}</div>
        </div>
        <div className={midas.cardFooter}>
          {props.actions.map(
            action =>
              action.typeName && (
                <Button
                  key={action.text}
                  typeName={action.typeName}
                  primaryColor={action.primaryColor}
                  styleName={action.styleName}
                  text={action.text}
                  onClick={action.func}
                  disabled={action.disabled}
                />
              ),
          )}
        </div>
      </div>
    </div>
  )
}

Dock.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  onBack: PropTypes.func,
  onMinimize: PropTypes.func,
  onBeforeCloseChat: PropTypes.func,
  actions: PropTypes.array,
  closeText: PropTypes.string,
  dockClass: PropTypes.string,
}

Dock.defaultProps = {
  children: null,
  title: '',
  actions: [],
  dockClass: '',
  closeText: '',
  onBack: null,
  onMinimize: null,
  onBeforeCloseChat: null,
}
